<template>
  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <v-row no-gutters class="form-group" v-if="!noLabel">
          <span v-if="label !== ''" class="item-label">{{ label }}</span>
          <span v-else class="item-label" style="color:white" />
          <label class="form-group-label">
          <span v-if="required && !readonly" class="mandatory-solo">必須</span>
          </label>
        </v-row>
        <v-text-field
          v-bind="computedProps"
          v-on="computedListeners"
          label=""
          solo
          flat
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0">
          <template v-slot:append>
            <slot name="append"/>
          </template>
        </v-text-field>
      </span>
      <div v-else>
        <v-row no-gutters class="form-group" v-if="!noLabel">
          <span v-if="label !== ''" class="item-label">{{ label }}</span>
          <span v-else class="item-label" style="color:white" />
          <label class="form-group-label">
          <span v-if="required && !readonly" class="mandatory-solo">必須</span>
          </label>
        </v-row>
        <v-text-field
          v-bind="computedProps"
          v-on="computedListeners"
          label=""
          solo
          flat
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0">
          <template v-slot:append>
            <slot name="append"/>
          </template>
        </v-text-field>
      </div>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用汎用テキスト
 * @namespace components
 */

/**
 * @vue-prop {controls.InputTypes} valueType - 入力タイプ
 * @vue-prop {Boolean} [required=false] - 必須指定
 * @vue-prop {Number} [length=999] - 入力可能桁数
 * @vue-prop {String} [errorMessages=''] - 表示エラーメッセージ
 * @vue-prop {String} [paddingChar=''] - 埋め込み文字列
 * @vue-prop {Function} [appendFormatter=undefined] - 追加フォーマッタ―
 * @vue-prop {Function} [appendUnFormatter=undefined] - 追加フォーマット解除処理
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @see controls.InputTypes
 * @example
  <dd-text-box
    label="数字"
    v-model="value"
    :length="25"
    :required="true"
    :valueType="controls.InputTypes.Number"/>
 */
export default {
  name: 'DdTextBox',
  extends: VTextField,
  mixins: [inputMixin],
  props: {
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 必須表示
     */
    showRequire: {
      type: Boolean,
      default: true
    },
    /**
     * 入力可能桁数
     */
    length: Number,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 埋め込み文字
     */
    paddingChar: String,
    /**
     * 追加フォーマッタ
     */
    appendFormatter: Function,
    appendUnFormatter: Function,
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * type
     */
    inputType: {
      type: String,
      default: 'text'
    }
  },
  data: () => ({
    invalidMessage: '',
    innerValue: ''
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    inputTypeDetail () {
      return controls.getInputTypeDetail(this.valueType)
    },
    phtext () {
      if (!this.inputTypeDetail) {
        return ''
      } else {
        return this.length && !this.readonly ? this.inputTypeDetail.placeholder.replace('@@length@@', this.length) : ' '
      }
    },
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        // ackgroundColor: this.required ? controls.Colors.Required : '',
        class: this.$props.class + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : ''),
        type: this.inputType,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      if (typeof this.appendUnFormatter === 'function' && this.appendUnFormatter) {
        this.innerValue = this.appendUnFormatter(this.innerValue)
      }
      const elem = this.$el.querySelector('input')
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        console.log(target, f.name)
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          // this.$set(this, 'invalidMessage', ret)
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
      if (typeof this.appendFormatter === 'function' && this.appendFormatter) {
        this.innerValue = this.appendFormatter(this.innerValue)
        this.$emit('input', this.innerValue)
        console.log(controls.FORMAT_METHOD, this.innerValue)
      }
    }
  }
}
</script>
<style scoped>
</style>
